import { useLocation, Navigate } from 'react-router-dom';
import { XCircle, Phone } from 'lucide-react';

export default function BookingCancelled() {
  const { state } = useLocation();

  if (!state?.message) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f5f8f6] to-brand-light flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl overflow-hidden animate-in fade-in zoom-in duration-500">
        {/* Header */}
        <div className="bg-brand-dark p-8 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4xKSIvPjwvc3ZnPg==')] opacity-20"></div>

          <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg relative z-10">
            <XCircle className="w-10 h-10 text-brand-dark" strokeWidth={3} />
          </div>

          <h1 className="text-2xl font-bold text-white relative z-10">
            Booking Cancelled
          </h1>
          <p className="text-gray-300 mt-2 relative z-10">
            Your appointment has been cancelled.
          </p>
        </div>

        {/* Details */}
        <div className="p-8 space-y-6">
          <div className="text-center">
            <p className="text-brand-dark/70 mb-6">
              If you would like to book a new appointment, please use the booking link from your reminder message or contact us directly.
            </p>
          </div>

          <div className="pt-4 border-t border-slate-100 text-center">
            <p className="text-brand-neutral text-sm mb-4">Need assistance?</p>
            <a
              href="tel:+971501234567"
              className="inline-flex items-center gap-2 bg-brand-primary text-white font-medium px-6 py-3 rounded-xl hover:bg-brand-primary/90 transition-all"
            >
              <Phone className="w-4 h-4" />
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
